import { Navigate } from 'react-router-dom';

import { DashboardRoute } from './dashboard-route';
import { AccessDeniedPanel } from '../components/layout/AccessDeniedPanel';
import { useAccount } from '../contexts/AccountContext';
import { firstAccessiblePath } from '../domain/access';

/**
 * `/` = tableau de bord. Il sert **deux** permissions : la table des courses
 * vit sur Courses, les indicateurs et les graphes sur Performance — depuis que
 * l'écran Performance est devenu Export, c'est ici qu'ils vivent. Porter l'une
 * ou l'autre suffit donc à y entrer ; le contenu, lui, s'adapte.
 *
 * Un appelant qui n'a ni l'une ni l'autre — un profil Facturation seul —
 * atterrit sur sa première page accessible.
 */
export const HomeRoute = () => {
  const { can, permissions } = useAccount();
  if (can('extranet-trips') || can('extranet-performance')) return <DashboardRoute />;

  const home = firstAccessiblePath(permissions);
  if (!home || home === '/') {
    return <AccessDeniedPanel description="Aucune page n'est accessible avec vos droits actuels." />;
  }
  return <Navigate to={home} replace />;
};
